<script setup>
const $props = defineProps({
    number: {
        type: Number,
        required: true
    }
});
</script>

<template>
    <a
        :aria-label="`Note ${$props.number}`"
        :href="`/methodology#note-${$props.number}`"
        class="market-note-mark font-mono text-caption text-weight-regular q-ml-xs"
    >[{{ $props.number }}]</a>
</template>

<style lang="scss" scoped>
.market-note-mark {
    vertical-align: baseline;
}
</style>
